<template>
  <div>
    <toggleswitch
      :labels="true"
      name="is_gta"
      label="Use GTA rates?"
      helper="Should we use GTA rates for this hire?"
      v-model="detailsForm.is_gta"
      v-if="canUseGtaRates"
    ></toggleswitch>

    <table
      class="table"
      v-if="tariffsLoaded && ratesLoaded && commercialTariff"
    >
      <thead>
        <tr>
          <th>Charge</th>
          <th></th>
          <th>Rate</th>
          <th>Commercial Rate</th>
          <th>Maximum Rate</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <hire-charge
          :rates="ratesForm.rates"
          :charge="charge"
          :tariff="tariff"
          :commercial-tariff="commercialTariff"
          :selected-tariff="tariff"
          :group="vehicleForm.group_id"
          :key="`charges-${chargeIndex}`"
          v-for="(charge, chargeIndex) in charges"
        ></hire-charge>

        <tr class="info">
          <td colspan="6">
            <strong>Extras</strong>
          </td>
        </tr>

        <hire-extra
          :rates="ratesForm.rates"
          :extra="extra"
          :tariff="tariff"
          :commercial-tariff="commercialTariff"
          :selected-tariff="tariff"
          :group="vehicleForm.group_id"
          :key="`extras-${extraIndex}`"
          :is-enabled="isEnabled(extra)"
          v-for="(extra, extraIndex) in extras"
        ></hire-extra>
      </tbody>
    </table>
  </div>
</template>
<script>
import HireCharge from '@/components/Modules/Deployment/Children/Children/Children/HireCharge';
import HireExtra from '@/components/Modules/Deployment/Children/Children/Children/HireExtra';

export default {
  props: {
    detailsForm: {
      type: Object,
      required: true
    },
    vehicleForm: {
      type: Object,
      required: true
    },
    ratesForm: {
      type: Object,
      required: true
    },
    hire: {
      type: Object,
      required: true
    },
    requiresNonStandard: {
      type: Boolean,
      default() {
        return false;
      }
    },
    hires: {
      type: Array,
      required: false
    },
    selectedTariff: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  components: {
    HireCharge,
    HireExtra
  },

  data() {
    return {
      ratesLoaded: false
    };
  },

  computed: {
    tariffsLoaded() {
      return this.$store.getters['Tariffs/loaded'];
    },

    tariffs() {
      return this.$store.getters['Tariffs/all'];
    },

    source() {
      return this.$store.getters['Incident/source'];
    },

    claimType() {
      return this.$store.getters['Incident/incidentClaimType'];
    },

    charges() {
      return this.$store.getters['CreditHireCharges/all'].filter(charge => {
        if (
          charge.name === 'collection_delivery_charge' &&
          this.isFirstHire &&
          this.claimType?.name === 'accident'
        ) {
          return true;
        }

        if (charge.name === 'non_standard' && this.requiresNonStandard) {
          return true;
        }

        return !charge.extra;
      });
    },

    chargeTypes() {
      return this.$store.getters['CreditHireChargeTypes/all'];
    },

    extras() {
      return this.$store.getters['CreditHireCharges/all'].filter(charge => {
        if (charge.name === 'collection_delivery_charge') {
          if (!this.isFirstHire && this.claimType?.name === 'accident') {
            return true;
          } else if (this.claimType?.name === 'accident') {
            return false;
          }
        }

        if (charge.name === 'non_standard' && this.requiresNonStandard) {
          return false;
        }

        return charge.extra;
      });
    },

    commercialTariff() {
      if (this.claimType?.name === 'cross_hire') {
        return this.selectedTariff;
      }

      return this.$store.getters['Tariffs/nonGta'];
    },

    canUseGtaRates() {
      return this.claimType?.name !== 'cross_hire';
    },

    tariff() {
      if (Object.keys(this.selectedTariff).length) {
        return this.selectedTariff;
      } else if (this.claimType?.name === 'intervention') {
        return this.tariffs.find(tariff => tariff.name === 'intervention');
      } else if (this.detailsForm.is_gta) {
        return this.tariffs.find(tariff => tariff.name === 'gta');
      }

      return this.tariffs.find(tariff => tariff.name === 'non_gta');
    },

    isFirstHire() {
      return this.hire?.identifier === this.hires[0]?.identifier;
    }
  },

  mounted() {
    this.setHireRates();
  },

  methods: {
    setHireRates() {
      this.ratesForm.rates = this.hire.vehicle?.rates || [];
      this.ratesLoaded = true;
    },
    isEnabled(extra) {
      return !this.isFirstHire && extra.name === 'collection_delivery_charge';
    }
  },

  watch: {
    hire() {
      this.setHireRates();
    }
  }
};
</script>
